import styled from 'styled-components';


export const MapDiv = styled.div(props => ({
    position: 'relative',
    height: props.height || "500px",
    width: props.height || "500px",
    ...props,
}))
